module.exports = __webpack_public_path__ + "static/media/Ripio.3775713f.svg";